import { component } from 'picoapp';
import router from '@/router.js';
import { gsap } from 'gsap';

const IS_CURRENT_CLASS = 'is-current-page';
const HOVER_CLASS = 'has-hover';

export default component((node) => {
  const header = document.querySelector('.js-header');
  const nav = document.querySelector('.js-navigation');
  const buttons = node.querySelectorAll('.js-open-nested-menu');
  const links = node.querySelectorAll('.js-menu-link');

  let navigationOpen = false;

  buttons.forEach((button) => {
    const menu = nav.querySelector(`[data-parent-link='${button.dataset.menu}'`);
    button.addEventListener('mouseenter', () => {
      const thisButton = button;
      openNestedMenu(menu);
      thisButton.classList.add(HOVER_CLASS);
    });
  });

  links.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      hideNavigation();
    });
  });

  header.addEventListener('mouseleave', () => {
    hideNavigation();
  });

  const showNavigation = () => {
    navigationOpen = true;
    gsap.to('.js-navigation', { autoAlpha: 1, y: 0 });
  };

  const hideNavigation = () => {
    navigationOpen = false;
    hideNestedMenus();
    removeHoverStates();
    gsap.to('.js-navigation', {
      autoAlpha: 0, y: '-100%'
    });
  };

  router.on('after', hideNavigation);

  const openNestedMenu = (menu) => {
    if (!navigationOpen) showNavigation();
    hideNestedMenus();
    gsap.to(menu, { duration: 0.2, pointerEvents: 'auto', autoAlpha: 1, overwrite: true });
  };

});

const removeHoverStates = () => {
  const header = document.querySelector('.js-header');
  const buttons = header.querySelectorAll(['.js-open-nested-menu', '.js-menu-link']);

  buttons.forEach(element => {
    element.classList.remove(HOVER_CLASS);
  });
};

export const hideNestedMenus = () => {
  removeHoverStates();
  gsap.to('.js-menu-nested', {
    autoAlpha: 0,
    pointerEvents: 'none'
  });
};

export const refreshMenuState = () => {
  const menus = document.querySelectorAll('.js-menu');

  menus.forEach(menu => {
    const links = menu.querySelectorAll(['a', 'button']);
    links.forEach(link => updateActiveClass(menu, link));
  });
};

const updateActiveClass = (menu, link) => {
  const isCurrentPage = link.href === window.location.href;
  const isChildLink = link.dataset.parentLink;

  if (isCurrentPage) {
    link.classList.add(IS_CURRENT_CLASS);

    isChildLink &&
      addActiveClassToParentLink(menu, link);


  } else {
    link.classList.remove(IS_CURRENT_CLASS);
  }
};

const addActiveClassToParentLink = (menu, link) => {
  const selector = `[data-menu="${link.dataset.parentLink}"]`;
  const parentLink = menu.querySelector(selector);
  parentLink.classList.add(IS_CURRENT_CLASS);
};